import React, { Component } from 'react';
import { Icon } from 'components/Icon';

export const pracownicyTable = [
  { caption: 'Imię i nazwisko', get: (row) => row.podpis, align: 'left', maximize: true },
  { caption: <Icon icon="fa fa-trash"/>, get: (row) => row.deleted ? <Icon icon="fa fa-trash"/> : "" },
]

